import React, { Component } from "react";
import { Mutation } from "react-apollo";
import { connect } from "react-redux";
import { Box } from "reflexbox";

import { deselectRelation } from "../../actions/select_actions";
import { dismissForm } from "../../actions/ui_actions";

import { registerRelation, updateRelationById } from "../../queries/relations";

import Input from "../../common/Dropdowns/_Input";
import RoleSelect from "../../common/Dropdowns/_RoleSelect";
import CountrySelect from "../../common/Dropdowns/_CountrySelect";

import { Panel, PanelType } from "office-ui-fabric-react/lib/Panel";

import { Modal } from "office-ui-fabric-react/lib/Modal";

import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { Formik, Form } from "formik";
import { adopt } from "react-adopt";

const register = ({ render }) => (
  <Mutation mutation={registerRelation}>
    {(mutation, result) => render({ mutation, result })}
  </Mutation>
);

const update = ({ render }) => (
  <Mutation
    mutation={updateRelationById}
    //TODO takes to long
    // refetchQueries={["allRelations"]}
  >
    {(mutation, result) => render({ mutation, result })}
  </Mutation>
);

const Composed = adopt({
  register,
  update
});

class RelationModalForm extends Component {
  dismissModal = () => {
    this.props.deselectRelation();
    this.props.dismissForm();
  };

  render() {
    const {
      id,
      name,
      role,
      code,
      adres,
      postindex,
      city,
      countryId,
      vat,
      eori,
      kvk,
      status,
      loadingAddr,
      loadingRoute,
      doorCode,
      color,
      about
    } = this.props.relation;

    const { addOrEdit } = this.props;

    return (
      <div>
        <Modal
          isOpen={this.props.visible}
          onDismiss={this.dismissModal}
          isBlocking={false}
          containerClassName="ms-modalExample-container"
          style={{
            height: '80vh',
            width: '80vw',
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch'
          }}
        >
          {/* <Panel
          className="form-panel"
          isBlocking={true}
          isOpen={this.props.visible}
          onDismiss={this.dismissModal}
          isLightDismiss={true}
          type={PanelType.smallFixed}
          headerText="Relation form"
          forceFocusInsideTram={false}
        > */}
          <Composed>
            {({ register, update }) => {
              return (
                <Formik
                  onSubmit={values => {
                    const {
                      role,
                      name,
                      email,
                      password,
                      code,
                      adres,
                      postindex,
                      city,
                      countryId,
                      vat,
                      eori,
                      kvk,
                      status,
                      loadingAddr,
                      loadingRoute,
                      doorCode,
                      color,
                      about
                    } = values;

                    addOrEdit === "add"
                      ? register
                          .mutation({
                            variables: {
                              role: role,
                              name: name,
                              email: email,
                              password: password
                            }
                          })
                          .then(res => {
                            update.mutation({
                              variables: {
                                id: res.data.registerRelation.relation.id,
                                name: name,
                                role: role,
                                code: code,
                                adres: adres,
                                postindex: postindex,
                                city: city,
                                countryId: countryId,
                                vat: vat,
                                eori: eori,
                                kvk: kvk,
                                status: status,
                                loadingAddr: loadingAddr,
                                loadingRoute: loadingRoute,
                                doorCode: doorCode,
                                color: color,
                                about: about
                              }
                            });
                          })
                          .then(this.dismissModal)
                      : update
                          .mutation({
                            variables: {
                              id: id,
                              name: name,
                              email: email,
                              password: password,
                              role: role,
                              code: code,
                              adres: adres,
                              postindex: postindex,
                              city: city,
                              countryId: countryId,
                              vat: vat,
                              eori: eori,
                              kvk: kvk,
                              status: status,
                              loadingAddr: loadingAddr,
                              loadingRoute: loadingRoute,
                              doorCode: doorCode,
                              color: color,
                              about: about
                            }
                          })
                          .then(this.dismissModal);
                  }}
                  initialValues={{
                    role: role,
                    name: name,
                    code: code,
                    adres: adres,
                    postindex: postindex,
                    city: city,
                    countryId: countryId,
                    vat: vat,
                    eori: eori,
                    kvk: kvk,
                    status: status,
                    loadingAddr: loadingAddr,
                    loadingRoute: loadingRoute,
                    doorCode: doorCode,
                    color: color,
                    about: about
                  }}
                  validate={(values, props) => {
                    const errors = {};
                    //TODO
                    if (!values.role) {
                      errors.role = "Required";
                    }
                    if (!values.email && addOrEdit === "add") {
                      errors.email = "Required";
                    }
                    if (!values.password && addOrEdit === "add") {
                      errors.password = "Required";
                    }
                    return errors;
                  }}
                  render={props => (
                    <Form>
                      <Box mt={1}>
                        <RoleSelect
                          name="role"
                          label="Role"
                          value={props.values.role}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.role}
                          touched={props.touched.role}
                        />
                        <Input
                          name="name"
                          label="Name"
                          value={props.values.name}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.name}
                          touched={props.touched.name}
                        />
                        {this.props.addOrEdit === "add" && (
                          <Box flex>
                            <Input
                              name="email"
                              label="Email"
                              value={props.values.email}
                              onChange={props.setFieldValue}
                              onBlur={props.setFieldTouched}
                              error={props.errors.email}
                              touched={props.touched.email}
                            />
                            <Input
                              type="password"
                              name="password"
                              label="Password"
                              value={props.values.passworde}
                              onChange={props.setFieldValue}
                              onBlur={props.setFieldTouched}
                              error={props.errors.password}
                              touched={props.touched.password}
                            />
                          </Box>
                        )}

                        <Input
                          name="code"
                          label="Code"
                          value={props.values.code}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.code}
                          touched={props.touched.code}
                        />
                        <Input
                          name="adres"
                          label="Adres"
                          value={props.values.adres}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.adres}
                          touched={props.touched.adres}
                        />
                        <Input
                          name="postindex"
                          label="Postindex"
                          value={props.values.postindex}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.postindex}
                          touched={props.touched.postindex}
                        />
                        <Input
                          name="city"
                          label="City"
                          value={props.values.city}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.city}
                          touched={props.touched.city}
                        />
                        <CountrySelect
                          name="countryId"
                          label="Country"
                          value={props.values.countryId}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.countryId}
                          touched={props.touched.countryId}
                        />
                        <Input
                          name="vat"
                          label="Vat"
                          value={props.values.vat}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.vat}
                          touched={props.touched.vat}
                        />
                        <Input
                          name="kvk"
                          label="kvk"
                          value={props.values.kvk}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.kvk}
                          touched={props.touched.kvk}
                        />
                        <Input
                          name="loadingAddr"
                          label="Loading Adres"
                          value={props.values.loadingAddr}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.loadingAddr}
                          touched={props.touched.loadingAddr}
                        />
                        <Input
                          name="loadingRoute"
                          label="Loading route"
                          value={props.values.loadingRoute}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.loadingRoute}
                          touched={props.touched.loadingRoute}
                        />
                        <Input
                          name="doorCode"
                          label="Door code"
                          value={props.values.doorCode}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.doorCode}
                          touched={props.touched.doorCode}
                        />
                        <Input
                          name="color"
                          label="Color"
                          value={props.values.color}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.color}
                          touched={props.touched.color}
                        />
                        <Input
                          name="about"
                          label="About"
                          value={props.values.about}
                          onChange={props.setFieldValue}
                          onBlur={props.setFieldTouched}
                          error={props.errors.about}
                          touched={props.touched.about}
                        />

                        <Box mt={1}>
                          <PrimaryButton
                            text="Submit"
                            type="submit"
                            disable={props.isSubmitting}
                          />
                        </Box>
                      </Box>
                    </Form>
                  )}
                />
              );
            }}
          </Composed>
          {/* </Panel> */}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    relation: state.selected.relation
  };
};

export default connect(
  mapStateToProps,
  {
    deselectRelation: deselectRelation,
    dismissForm: dismissForm
  }
)(RelationModalForm);



// WEBPACK FOOTER //
// ./src/common/Forms/_RelationModalForm.js